import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

const useStyles = makeStyles((theme: any) => ({
  cell: { position: "relative" },
  expandCell: { width: 50 },
  editTip: {
    position: "absolute",
    bottom: 0,
    left: theme.spacing(2),
    fontSize: "0.7rem",
  },
}));

interface IProps {
  headers: Array<string>;
}

export default function PlansTableHeader({ headers }: IProps) {
  const classes = useStyles();

  return (
    <TableHead>
      <TableRow>
        {headers.map((header, i) => (
          <TableCell
            key={i}
            className={classes.cell + " " + (i === 0 && classes.expandCell)}
          >
            <b>{header}</b>
            {header === "Plan name" && (
              <span className={classes.editTip}>(Click to edit)</span>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
